import unpolyLinkHelper from '../modules/unpoly_link_helper'

const DEFAULT_TARGET = ':main'

up.macro('[content-link]', (link) => {
  const $link = $(link)

  let target = $link.attr('content-link') || DEFAULT_TARGET
  let attrs = {
    'up-target': target,
    'up-transition': 'cross-fade',
    'up-duration': '150',
  }

  unpolyLinkHelper.setAttributes($link, attrs)
})
